import { RESEARCH_SET_PAGE } from "../constants/research";
import { beginExercise } from "../actions/grades";

const questionLoader = ({ dispatch, getState }) => next => {
  // once we check an exercise we don't need to check it again
  let checked = [];

  return action => {
    const page = action.page;
    if (action.type === RESEARCH_SET_PAGE && !checked.includes(page.code)) {
      if (page.category === "quiz" || page.category === "worksheet") {
        // check to see if we have questions loaded for this exercise
        const numQuestions = getState().research.questions.filter(
          q => q.exerciseCode === page.code
        ).length;
        if (numQuestions === 0) {
          dispatch(beginExercise(page.code));
        }
      }

      checked.push(page.code);
    }

    return next(action);
  };
};

export default questionLoader;
